function chunkerizeArray<ArrayContentType = any>(array: Array<ArrayContentType> = [], chunkSize: number = 25) {
  const finalArray: Array<Array<ArrayContentType>> = []
  if (Array.isArray(array) && typeof chunkSize === 'number') {
    for (let i = 0; i < array.length; i++) {
      if (i % chunkSize === 0) {
        finalArray.push([])
      }
      const chunkIndex = parseInt(`${i / chunkSize}`, 10)
      finalArray[chunkIndex].push(array[i])
    }
  }
  return finalArray
}

export default chunkerizeArray
